<template>
  <div class="main-page">
    <app-page-wrapper-grid>
      <seat-picker></seat-picker>
    </app-page-wrapper-grid>
  </div>
</template>

<script>
import SeatPicker from "./../../components/venue/seat-picker/SeatPicker";
import AppPageWrapperGrid from "./../../components/base/app-page-wrapper-grid/AppPageWrapperGrid.vue";
import { showToaster } from "@/utils";

export default {
  name: "VenueContainer",
  components: {
    SeatPicker,
    AppPageWrapperGrid
  },
  data() {
    return {
      errorMessage: {}
    };
  },
  mounted() {
    if (this.errorMessage && Object.keys(this.errorMessage).length !== 0) {
      showToaster.call(this, {
        errorMessage: this.errorMessage
      });
    }
  }
};
</script>

<style lang="scss">
.main-page {
  box-sizing: border-box;
  width: 100%;
  min-height: calc(100vh - 136px);
  @include respond-to-mobile {
    min-height: calc(100vh - 132px);
  }
  background-color: $group-2-color-1;
}

.container {
  width: 100%;
  max-width: 1250px;
  box-sizing: border-box;
  margin: auto;
  @include respond-to-laptop {
    max-width: 750px;
  }

  @include respond-to-mobile {
    width: 100%;
  }
}
</style>
